/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box } from "@mui/material";
import React from "react";
import loadingImg from "../../assets/images/loader2.gif";

export const Loader = ({sx, height}) => {
  return (
    <Box align="center" sx={{ alignSelf: "center", py: 3, ...sx }}>
      <img style={{ height: height ? height : 80 }} src={loadingImg} alt="loading..." />
    </Box>
  );
};
